import { render, staticRenderFns } from "./OrderOptic.vue?vue&type=template&id=182dd498"
import script from "./OrderOptic.vue?vue&type=script&lang=js"
export * from "./OrderOptic.vue?vue&type=script&lang=js"
import style0 from "./OrderOptic.vue?vue&type=style&index=0&id=182dd498&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports